/** ADR-061: the stage every world, lesson check and headset uses. */
export const STAGE = {
    stand: 2,
    radius: 6,
    floor: 2,
    clear: 4.5,
    // ADR-084 (PO, 29 Oct 2026): a big model may come to 3 m from the pupil.
    modelClear: 3,
    modelEyes: 3,
    clearHeight: 2.5,
    apronHeight: 0.05,
    below: 0.02,
    strictStand: true,
};
/**
 * ADR-084: where the platform itself offers a big model a place -- its spots, lanes, rings and close-up
 * (model-spots.ts, model-rings.ts) -- it keeps the distances those were tuned for: 6 m from the eyes and
 * outside the clear space. A lesson may bring the model to 3 m (`modelEyes`, `modelClear`); the offer does
 * not move nearer, so a run still leaves the lectern room, a ring still starts on a spot, and a T. rex
 * still has its walk back. ADR-032's stage offers what it rules (6 m and 8.5 m).
 */
export const OFFER_EYES = 6;
/** `stage` with the distances its offered places keep (ADR-084). */
export function offerStage(stage) {
    return {
        ...stage,
        modelEyes: Math.max(stage.modelEyes, OFFER_EYES),
        modelClear: Math.max(stage.modelClear, stage.clear),
    };
}
/**
 * ADR-032's stage, frozen: the generator's prompts before code prompt v7 (stored guidelines < 9) and
 * their checks are made with it, so they stay byte for byte as they were (ADR-055's rule); and what
 * was built round it (the code worlds' remnants, the kit examples not rebuilt) keeps its sizes.
 */
export const STAGE_ADR032 = {
    stand: 6,
    radius: 6,
    floor: 8.5,
    clear: 8.5,
    modelClear: 8.5,
    modelEyes: 6,
    clearHeight: 4.4,
    apronHeight: 0.05,
    below: 0.02,
    strictStand: false,
};
//# sourceMappingURL=stage.js.map